import { type SyntheticEvent, useState } from "react";
import { Button } from "../../base/button";
import { InputText } from "../../base/input/input-text";
import { Label } from "../../base/label";
import { HorizontalSpacer } from "../../layout/horizontal-spacer";
import { PageContent } from "../../layout/page-content";
import { VerticalContainer } from "../../layout/vertical-container";
import { Text } from "../../ui/text";

interface DiscountCodeFormProps {
  activeDiscountCode: string | undefined;
  handleSetDiscountCode: (discountCode: string | null) => void;
  errorMessage?: string;
}

export const DiscountCodeForm = ({
  activeDiscountCode,
  handleSetDiscountCode,
  errorMessage,
}: DiscountCodeFormProps) => {
  const [tempDiscountCode, setTempDiscountCode] = useState<string>(activeDiscountCode ?? "");

  return (
    <PageContent width="x-small">
      <Text value="Har du en kampanjekode?" weight="bold" />
      <VerticalContainer horizontalPlacement="center">
        <HorizontalSpacer size="xx-small" />

        <Label hidden={true} htmlFor="campaign-code-input" value="Har du en kampanjekode?" />
        <InputText
          disabled={activeDiscountCode !== "" && activeDiscountCode !== undefined}
          externalValidationError={errorMessage}
          id={"campaign-code-input"}
          name={"Kampanjekode"}
          onChange={(e) => {
            setTempDiscountCode(e.target.value.toLocaleUpperCase());
          }}
          placeholder="Skriv inn koden din her"
          readOnly={activeDiscountCode !== "" && activeDiscountCode !== undefined}
          value={tempDiscountCode}
        />
        <HorizontalSpacer size="x-small" />

        {activeDiscountCode ? (
          <Button
            buttonType="secondary"
            onClick={(e: SyntheticEvent) => {
              e.preventDefault();
              setTempDiscountCode("");
              handleSetDiscountCode(null);
            }}
          >
            <Text size="small" value="Fjern kode" />
          </Button>
        ) : (
          <Button
            buttonType="neutral"
            onClick={(e: SyntheticEvent) => {
              e.preventDefault();
              handleSetDiscountCode(tempDiscountCode);
            }}
          >
            <Text size="small" value="Bruk kode" />
          </Button>
        )}
        <HorizontalSpacer size="x-small" />

        {activeDiscountCode && (
          <Text color="gray" size="small" value={`Aktiv kode: ${activeDiscountCode}`} weight="bold" />
        )}
      </VerticalContainer>
    </PageContent>
  );
};
